import i18next from 'i18next';
// import { initReactI18next } from 'react-i18next';

import en from './locales/en';

i18next.init({
  lng: 'en',
  resources: {
    en: {
      translation: en,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});
// i18next.use(initReactI18next).init({
//   lng: 'en',
//   fallbackLng: 'en',
//   resources: {
//     en: {
//       translation: en,
//     },
//   },
//   interpolation: {
//     escapeValue: false,
//   },
// });
export const t = i18next.t.bind(i18next);
export default i18next;
